import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  navIcon: {
    width: "20px",
  },
  reduceOpacity: {
    opacity: "0.3",
    pointerEvents: "none",
  },
}));

const ListPagination = (props) => {
  const { nextPage, prevPage, handleNavClick, currentPageLastEvaluatedKey, lastEvaluatedKeysList } = props;
  const classes = useStyles();

  const handleClick = (action) => {
    handleNavClick(action);
  };

  const getPrevClassName = () => {
    const baseClass = "prev-bar flex items-center cursor-pointer mr-12";
    const shouldReduceOpacity = lastEvaluatedKeysList
        ? lastEvaluatedKeysList.length < 2
        : prevPage < 1;

    return shouldReduceOpacity
        ? `${baseClass} ${classes.reduceOpacity} reducedOpacity`
        : baseClass;
  };

  const getNextClassName = () => {
    const baseClass = "next-bar flex items-center cursor-pointer";
    const shouldReduceOpacity = currentPageLastEvaluatedKey
        ? currentPageLastEvaluatedKey === ""
        :  nextPage === -1

    return shouldReduceOpacity
        ? `${baseClass} ${classes.reduceOpacity} reducedOpacity`
        : baseClass;
  };

  return (
    <div
      className={"flex justify-end items-center pagination-component p-16 pr-0"}
    >
      <div id="navArrows" className={"nav-arrows flex justify-between center"}>
        <div
          onClick={() => handleClick("prev")}
          className={getPrevClassName()}
        >
          <img
            className={`${classes.navIcon}`}
            src={"/images/left-arrow.svg"}
            alt="left"
          />
          <span>Prev</span>
        </div>
        <div
          onClick={() => handleClick("next")}
          className={getNextClassName()}
        >
          <span>Next</span>
          <img
            className={`${classes.navIcon}`}
            src={"/images/right-arrow.svg"}
            alt="right"
          />
        </div>
      </div>
    </div>
  );
};

ListPagination.defaultProps = {
  nextPage: -1,
  prevPage: -1,
};

ListPagination.propTypes = {
  nextPage: PropTypes.number,
  prevPage: PropTypes.number,
  handleNavClick: PropTypes.func,
};

export default ListPagination;
